
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import api from '../../api';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
Group,
XInput,
XButton,
},
mounted() {
},
activated() {
},
data() {
return {
formData: {
newPwd: '',
oldPwd: ''
},
newPwd: '',
};
},
computed: {
},
methods: {
saveForm() {
if (this.newPwd !== this.formData.newPwd) {
this.$vux.toast.text('请确保两次密码相同');
} else {
const _this = this;
api.vega.user.modifyPasswd(this.formData).then((res) => {
const code = res.data;
if (code.code === 0 && code.sub_code === 0) {
this.$vux.confirm.show({
showCancelButton: false,
confirmText: '我知道了',
content: `<i class="iconfont icon-chenggong"></i>
<p class="save_ok">保存成功</p>`,
onConfirm () {
_this.$router.go(-1);
}
});
}
});
}
},
},
};
